import { lazy } from 'react';

export const LazyHubspotClosePage = lazy(
  () =>
    import(
      /* webpackChunkName: "hellospa--page--hubspot-close-page" */ './hubspot-close-page'
    ),
);
